/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    User,
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationNotificationStatsMetadata
 */
export interface DelegationNotificationStatsMetadata {
    /**
     * Number of newly assigned questions user can be notified about
     * @type {number}
     * @memberof DelegationNotificationStatsMetadata
     */
    count: number;
    /**
     * Direction in which delegation notification is sent
     * 
     * - `forward` - Assignor notifies assignee: "Please fill these questions."
     * - `backward` - Assignee notifies assignor: "These questions are now filled."
     * @type {string}
     * @memberof DelegationNotificationStatsMetadata
     */
    direction: DelegationNotificationStatsMetadataDirectionEnum;
    /**
     * User to whom the notification can be sent
     * @type {User}
     * @memberof DelegationNotificationStatsMetadata
     */
    user: User;
}

export function DelegationNotificationStatsMetadataFromJSON(json: any): DelegationNotificationStatsMetadata {
    return DelegationNotificationStatsMetadataFromJSONTyped(json, false);
}

export function DelegationNotificationStatsMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationNotificationStatsMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'direction': json['direction'],
        'user': UserFromJSON(json['user']),
    };
}

export function DelegationNotificationStatsMetadataToJSON(value?: DelegationNotificationStatsMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'direction': value.direction,
        'user': UserToJSON(value.user),
    };
}

/**
* @export
* @enum {string}
*/
export enum DelegationNotificationStatsMetadataDirectionEnum {
    Backward = 'backward',
    Forward = 'forward'
}


